import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class AiUsage extends Model {
  [Type] = 'reviews/ai-usage' as const;

  @attr('number') declare amountOfGenerations: number;
  @attr('string') declare subscriptionId: string;
  @attr('boolean') declare unlimited: boolean;
}
